const SELF_CLOSING_TAGS = ['HR', 'IMG', 'INPUT'];

// Check if any of the childNodes have any content which is not an empty string (whitespace).
export function hasChildContent(childNodes: NodeList | Array<any>): boolean {
  return Array.from(childNodes).some((node: any) => {
    if (node.nodeType === Node.TEXT_NODE) return (node.textContent?.trim().length || 0) > 0;
    if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.slot) {
        return SELF_CLOSING_TAGS.includes(node.tagName) || hasChildContent(node.childNodes);
      } else {
        return true;
      }
    }
    return false;
  });
}

// Show a slot and it's assignedNodes if there are any child elements.
export function showSlotContent(event: any) {
  const slot = event.target;
  if (slotHasAnyContent(slot)) {
    slot.hidden = false;
  } else {
    slot.hidden = true;
  }
}

// Show a slot's *parentElement* if the slot has any child elements.
export function showSlotParentContent(event: any) {
  const slot = event.target;
  const parent = slot.parentElement;
  if (slotHasAnyContent(slot)) {
    parent.hidden = false;
  } else {
    parent.hidden = true;
  }
}

export function showSlotPreviousSiblingContent(event: any) {
  const slot = event.target;
  const parent = slot.parentElement;
  const previousElementSibling = parent.previousElementSibling;
  previousElementSibling.hidden = !slotHasAnyContent(slot);
}

// Determine if a slot has any child nodes or assignedNodes.
export function slotHasAnyContent(slot: HTMLSlotElement) {
  if (!slot) return false;
  const assignedElements = slot.assignedNodes();
  const childNodes = assignedElements.length ? assignedElements : slot.childNodes;
  return hasChildContent(childNodes);
}

// On the `slotchange` event, check to see if a slot has any child nodes or assignedNodes.
// If it does not, then add an `empty` class to the slot so it can be hidden in the UI
export function hideIfSlotEmpty(
  slot: HTMLSlotElement | null | undefined,
  elemToBeHidden: HTMLElement | null | undefined = undefined,
) {
  elemToBeHidden ||= slot;
  if (!elemToBeHidden) return;
  if (!slot) return;

  slotHasAnyContent(slot)
    ? elemToBeHidden.style.removeProperty('display')
    : elemToBeHidden.style.setProperty('display', 'none', 'important');
}

// Keep track of original hidden attribute (since it may have already been set before we did anything to it)
export const originalHostHiddenState = new WeakMap();

// Hide entire host if particular slot is empty.
export function hideHostIfSlotEmpty(slot: HTMLSlotElement) {
  const shadowRoot = slot.getRootNode() as ShadowRoot;
  const host = shadowRoot.host as HTMLElement;
  if (host) {
    if (originalHostHiddenState.get(host) === 'undefined') {
      originalHostHiddenState.set(host, host.hidden);
    }

    if (slotHasAnyContent(slot)) {
      host.hidden = originalHostHiddenState.get(host);
      originalHostHiddenState.delete(host);
    } else {
      host.hidden = true;
    }
  }
}
